/* unplugin-vue-components disabled */import { render } from "./custom-menu.vue?vue&type=template&id=4431124b&scoped=true"
import script from "./custom-menu.vue?vue&type=script&lang=js"
export * from "./custom-menu.vue?vue&type=script&lang=js"

import "./custom-menu.vue?vue&type=style&index=0&id=4431124b&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/e-bike/e-bike-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4431124b"]])

export default __exports__